export const COLORS = {
  BLUE: "BLUE",
  GREY: "GREY",
  WHITE: "WHITE"
};

export type Color = keyof typeof COLORS;

export const BACKGROUNDS = {
  LIGHT_BLUE: "LIGHT_BLUE"
};

export type Background = keyof typeof BACKGROUNDS;
